// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"527d9774","455":"c8038a79"}[chunkId] + ".chunk.js";
};